import { addMessages } from '@hana/i18n';

// Khoá chuỗi Ezy › Dịch vụ › Định mức (màn rộng + iPad dùng chung). Mã phí, tên riêng và dữ liệu không dịch.
addMessages('vi', {
  'nrm.portUnit': 'Cảng / kho · đơn vị', 'nrm.info': 'Thông tin', 'nrm.back': 'Quay lại',
  'nrm.privTip': 'Chỉ trả cho bên tư nhân',
  'nrm.priv': 'Chỉ bên tư nhân',
  'nrm.ndc': 'NDC · Không chứng từ',
  'nrm.c.code': 'Mã',
  'nrm.c.fee': 'Tên phí',
  'nrm.c.rcpt': 'Loại người nhận',
  'nrm.port': 'Cảng / kho',
  'nrm.unit': 'Đơn vị',
  'nrm.c.norm': 'Định mức ₫',
  'nrm.thr': 'Ngưỡng lệch',
  'nrm.apr': 'Duyệt khi vượt',
  'nrm.eff': 'Hiệu lực',
  'nrm.view': 'Xem định mức · {code} · {name}',
  'nrm.pending': 'chờ cấp',
  'nrm.unset': 'Chưa chọn',
  'nrm.nextTip': '{v} · {st} · từ {from} · {amt}',
  'nrm.k.norm': 'Định mức',
  'nrm.edit': 'Sửa định mức',
  'nrm.askTitle': 'Ask HANA · Đề xuất định mức',
  'nrm.suggest': 'Đề xuất định mức',
  'nrm.clone': 'Nhân bản sang cảng / kho khác',
  'nrm.stop': 'Ngừng áp dụng',
  'nrm.viewing': 'Đang xem {v} · {st}',
  'nrm.current': 'Bản hiện hành',
  'nrm.service': 'Dịch vụ',
  'nrm.docs': 'Chứng từ áp dụng',
  'nrm.nature': 'Bản chất mặc định',
  'nrm.group': 'Nhóm',
  'nrm.supFee': 'Phí hỗ trợ dịch vụ {sv}',
  'nrm.closeSug': 'Đóng đề xuất',
  'nrm.vsCur': 'So với định mức hiện hành',
  'nrm.sugThr': 'Ngưỡng đề xuất',
  'nrm.basis': 'Căn cứ',
  'nrm.over': 'vượt {a}/{b}',
  'nrm.newVer': 'Tạo bản mới',
  'nrm.actual': 'Thực tế 90 ngày',
  'nrm.limit': 'Ngưỡng',
  'nrm.count': 'Lần phát sinh',
  'nrm.avg': 'Trung bình',
  'nrm.overN': 'Số lần vượt',
  'nrm.chart': 'Thực tế trung bình theo tuần, 90 ngày',
  'nrm.week': 'Tuần {n} · TB {avg}',
  'nrm.versions': 'Phiên bản',
  'nrm.seeV': 'Xem {v}',
  'nrm.history': 'Lịch sử thay đổi',
  'nrm.to': 'thành',
  'nrm.noWrite': 'Chưa mở ghi ở bản này',
  'nrm.soon': '{what} chưa mở ở bản này',
  'nrm.title': 'Định mức theo dịch vụ',
  'nrm.waitT': 'Định mức chờ duyệt',
  'nrm.waitN': '{n} định mức chờ duyệt',
  'nrm.schedT': 'Sắp áp dụng',
  'nrm.schedN': '{n} định mức sắp áp dụng',
  'nrm.allPorts': 'Tất cả cảng / kho',
  'nrm.imp': 'Nhập Excel',
  'nrm.exp': 'Xuất Excel',
  'nrm.add': 'Thêm định mức',
  'nrm.empty': 'Chưa có định mức',
  'nrm.emptyDesc': 'Định mức theo dịch vụ sẽ hiện ở đây.',
  'nrm.retry': 'Thử lại',
  'nrm.noperm': 'Không có quyền xem định mức.',
  'nrm.all': 'Tất cả',
  'nrm.std': 'Định mức chung',
  'nrm.waitS': '{n} chờ duyệt',
  'nrm.paneLabel': 'Định mức · {name}',
  'nrm.countT': 'Số định mức',
  'nrm.allVers': 'Tất cả bản',
  'nrm.none': 'Chưa có định mức.',
});
addMessages('en', {
  'nrm.portUnit': 'Port / depot · unit', 'nrm.info': 'Information', 'nrm.back': 'Back',
  'nrm.privTip': 'Paid to private parties only',
  'nrm.priv': 'Private parties only',
  'nrm.ndc': 'NDC · No documents',
  'nrm.c.code': 'Code',
  'nrm.c.fee': 'Fee name',
  'nrm.c.rcpt': 'Recipient type',
  'nrm.port': 'Port / depot',
  'nrm.unit': 'Unit',
  'nrm.c.norm': 'Norm ₫',
  'nrm.thr': 'Variance threshold',
  'nrm.apr': 'Approval when exceeded',
  'nrm.eff': 'Effective',
  'nrm.view': 'View norm · {code} · {name}',
  'nrm.pending': 'pending',
  'nrm.unset': 'Not selected',
  'nrm.nextTip': '{v} · {st} · from {from} · {amt}',
  'nrm.k.norm': 'Norm',
  'nrm.edit': 'Edit norm',
  'nrm.askTitle': 'Ask HANA · Suggest norm',
  'nrm.suggest': 'Suggest norm',
  'nrm.clone': 'Duplicate to another port / depot',
  'nrm.stop': 'Stop applying',
  'nrm.viewing': 'Viewing {v} · {st}',
  'nrm.current': 'Current version',
  'nrm.service': 'Service',
  'nrm.docs': 'Applicable documents',
  'nrm.nature': 'Default nature',
  'nrm.group': 'Group',
  'nrm.supFee': '{sv} service support fees',
  'nrm.closeSug': 'Close suggestion',
  'nrm.vsCur': 'Compared with the current norm',
  'nrm.sugThr': 'Suggested threshold',
  'nrm.basis': 'Basis',
  'nrm.over': 'over {a}/{b}',
  'nrm.newVer': 'Create new version',
  'nrm.actual': 'Last 90 days actual',
  'nrm.limit': 'Threshold',
  'nrm.count': 'Occurrences',
  'nrm.avg': 'Average',
  'nrm.overN': 'Times exceeded',
  'nrm.chart': 'Weekly average actual, 90 days',
  'nrm.week': 'Week {n} · avg {avg}',
  'nrm.versions': 'Versions',
  'nrm.seeV': 'View {v}',
  'nrm.history': 'Change history',
  'nrm.to': 'to',
  'nrm.noWrite': 'Write is not enabled in this version',
  'nrm.soon': '{what} is not available in this version yet',
  'nrm.title': 'Norms by service',
  'nrm.waitT': 'Norms awaiting approval',
  'nrm.waitN': '{n} norms awaiting approval',
  'nrm.schedT': 'Upcoming',
  'nrm.schedN': '{n} norms upcoming',
  'nrm.allPorts': 'All ports / depots',
  'nrm.imp': 'Import Excel',
  'nrm.exp': 'Export Excel',
  'nrm.add': 'Add norm',
  'nrm.empty': 'No norms yet',
  'nrm.emptyDesc': 'Norms by service will appear here.',
  'nrm.retry': 'Retry',
  'nrm.noperm': 'You do not have permission to view norms.',
  'nrm.all': 'All',
  'nrm.std': 'General norms',
  'nrm.waitS': '{n} awaiting approval',
  'nrm.paneLabel': 'Norms · {name}',
  'nrm.countT': 'Number of norms',
  'nrm.allVers': 'All versions',
  'nrm.none': 'No norms yet.',
});
